// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import isRetina from 'is-retina';
import Link from 'react-router-dom/Link';
import Color from 'color';

import { colors, transition } from '../style';

import {
  selectors as FromCategories
} from '../../redux/modules/categories';

const SIZE = 150;

const imgSrc = {
  doctor: isRetina() ? require('./doctor@2x.png') : require('./doctor.png'),
  patient: isRetina() ? require('./patient@2x.png') : require('./patient.png'),
};

const Root = styled(Link)`
  position: relative;

  width: ${SIZE}px;
  height: ${SIZE}px;

  &:before {
    content: '';

    position: absolute;
    left: 3px;
    right: 3px;
    top: 3px;
    bottom: 3px;
    transform: translateY(3px);

    border-radius: 50%;

    filter: blur(6px);

    background: linear-gradient(to bottom left, ${props => Color(props['data-start-color']).toString()}, ${props => Color(props['data-end-color']).fade(0.3).toString()});

    transition: all .3s ${transition.timingFunction};
  }
`;

const Face = styled.img`
  position: relative;
  z-index: 9;
`;

type ComponentProps = {
  contentType: string,
  startColor: string,
  endColor: string,
}

function Coin({ contentType, startColor, endColor }: ComponentProps) {
  return (
    <Root
      to={`/${contentType}`}
      data-start-color={startColor}
      data-end-color={endColor}
    >
      <Face
        width={SIZE}
        height={SIZE}
        src={imgSrc[contentType]}
        alt="Coin"
      />
    </Root>
  );
}

type Props = {
  selected: boolean,
  contentType: string,
  categoryId: number,
  parentCategoryId: number,
}

function mapStateToProps(state, props: Props) {
  if (!props.selected) return ({ categoryColor: colors.darkGrey });

  const category = FromCategories.getById(state.categories, props.categoryId);
  const parent = FromCategories.getById(state.categories, props.parentCategoryId);

  const startColor = category && category.color
      ? category.color
      : (parent && parent.color ? parent.color : colors.darkGrey);
  const endColor = startColor !== colors.darkGrey
    ? (parent && parent.color ? parent.color : startColor)
    : colors.darkGrey

  return ({
    startColor,
    endColor,
  });
}

export default connect(mapStateToProps)(Coin);



// WEBPACK FOOTER //
// ./src/components/Directions/Coin.js